// extracted by mini-css-extract-plugin
export default {"primary_input":"input_primary_input__qddBP"};